export default "20260427.1 \r\n"